<template>
	<div
		:class="{
			promo: true,
			promo_horizontal: display === 'horizontal',
			promo_vertical: display === 'vertical',
			promo_tile: display === 'tile',
			promo_title: display === 'title',
			promo_description: display === 'description'
		}">
		<loading v-if="loading"></loading>
		<template v-else>
			<button class="promo-control rollover" v-for="(row, i) in rows" :key="i" @click="Open(row)">
				<!-- The on-hover links -->
				<a
					class="disable-link"
					v-if="row.pageURL"
					target="_blank"
					:href="'https://www.boyden.com' + row.pageURL"></a>
				<router-link
					v-else-if="
						!row.pageURL &&
						(row.type.Identifier == 'SitesPageEvent' ||
							row.type.Identifier == 'SitesPageCaseStudy' ||
							row.type.Identifier == 'SitesPageBlogPost' ||
							row.type.Identifier == 'SitesPageMediaFile')
					"
					:to="{ name: '_learnMore', query: { oid: row.oid } }"></router-link>
				<router-link v-else :to="{ name: row.VueRouterName }"></router-link>
				<!-- View -->
				<div
					:class="{
						'img-wrap': true,
						pointer: true,
						'large-tile': display === 'tile'
					}"
					v-if="DataUrl(row) && !['title', 'description'].includes(display)">
					<img
						v-if="!row.HideImage"
						class="promoImage"
						:src="DataUrl(row)"
						@error="row.HideImage = true" />
					<img v-else class="promoImage" src="@/assets/images/default.jpeg" />
					<div v-if="display == 'tile'" class="overlay">
						{{ Truncate(row.title) }}
					</div>
				</div>
				<div class="content-wrap" v-if="display !== 'tile'">
					<h3 class="mb-3">{{ row.title }}</h3>
					<p class="mb-3" v-if="display != 'title'" v-html="row.metaDescription"></p>
					<div>
						<a href="#">-&nbsp;Read&nbsp;more</a>
					</div>
				</div>
			</button>
		</template>
	</div>
</template>
<script>
	import { ref, inject, computed, onMounted } from "vue";
	import { useRouter } from "vue-router";

	export default {
		props: {
			display: {
				type: String,
				default: "description"
			},
			filters: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		setup(props, context) {
			const http = inject("$http");
			const $json = inject("$json");
			const $router = useRouter();

			const loading = ref(true);
			const promos = ref([]);

			const rows = computed(() => {
				return promos.value;
			});

			const DataUrl = (row) => {
				if (row.type.Identifier == "OlympusWebPage") {
					return process.env.VUE_APP_API + "api/v2/cms/image/MetaImage/" + row.oid + "/224/224";
				} else {
					return process.env.VUE_APP_API + "api/v2/cms/image/TileImage/" + row.oid + "/224/224";
				}
			};

			const Open = (row) => {
				if (row.pageURL) {
					window.open("https://www.boyden.com" + row.pageURL, "_blank");
				} else {
					if (row.type.Identifier == "OlympusWebPage") $router.push({ name: row.VueRouterName });
					else $router.push({ name: "_learnMore", query: { oid: row.oid } });
				}
			};

			const GetPromos = async () => {
				loading.value = true;
				try {
					const response = await http.post("/api/v2/widget/promos", { filter: props.filters });
					promos.value = response.data;
					promos.value.forEach((row) => {
						GetPageOG(row);
					});
				} catch (err) {
					//error.value = err.response.data;
					console.error(err);
				}
				loading.value = false;
			};

			const GetPageOG = async (row) => {
				if (row.type.Identifier == "OlympusWebPage") {
					try {
						const response = await http.get("/api/v2/page/og/" + row.uuid);
						row.og = response.data;
						return response;
					} catch (err) {
						row.og = { error: err };
					}
				}
			};

			const Truncate = (str) => {
				let len = 26;

				if (str.length > len) {
					len = str.indexOf(" ", len);
					if (len == -1) return str;
					if (len > str.length) len = str.length;

					return str.substring(0, len) + "...";
				} else {
					return str;
				}
			};

			onMounted(() => {
				GetPromos();
			});

			return {
				loading,
				promos,
				rows,
				Open,
				DataUrl,
				Truncate
			};
		}
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/globalVars.scss";

	.disable-link {
		pointer-events: none;
	}

	.promo-control {
		margin: 0;
		border: none;
		border-radius: $radius-small;
		//width: 100%;
		padding: 0;
		background-color: transparent;
		text-align: left;
		line-height: pxUnits(24);

		&:hover {
			cursor: pointer;
			//background-color: $boyden-blue-lighter;

			& .link-button {
				background-color: lighten($boyden-blue-lighter, 3%);
			}
			& .link-icon {
				background-color: lighten($boyden-blue-lighter, 3%);
			}
		}
	}

	.promo {
		//margin-bottom: $margin-element-medium;
		$column-size: 20rem;
		$row-size: 14rem;

		& .img-wrap {
			&.large-tile {
				height: 18rem;
				max-height: 18rem;
				width: 18rem;
				max-width: 18rem;
			}

			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			position: relative;

			border-radius: $radius-medium;
			height: $row-size;
			max-height: $row-size;
			width: $row-size;
			min-width: $row-size;

			background-color: rgba(0, 0, 0, 0.2);

			& img {
				height: 100%;
				width: auto;
				max-width: unset;
			}

			& > .overlay {
				position: absolute;
				bottom: 0;
				align-items: center;
				justify-content: center;
				opacity: 1;
				border-radius: 0 0 $radius-medium $radius-medium;
				height: 4em !important;
				width: 100%;
				background-color: rgba(#00aeef, 0.8);
				font-size: 1em;
				text-align: center;
				position: absolute;
				bottom: 0;
				display: flex;
				flex-direction: column;

				box-sizing: border-box;

				transition: opacity 0.25s ease-out;

				font-weight: 700;
				letter-spacing: 0.05em;
				color: #fff;
			}
		}

		&.promo_horizontal {
			@include grid-minmax(20rem, 1fr);
			grid-column-gap: $margin-element-large;
			grid-row-gap: $margin-body-medium;
			// display: flex;
			// flex-direction: row;
			// flex-wrap: wrap;
			// justify-content: flex-start;

			width: 100%;

			& > .promo-control {
				display: flex;
				flex-direction: column;
				max-width: 300px;

				//width: $column-size;

				& > .img-wrap {
					position: relative;
					width: 100%;
					padding-top: 100%;

					& > img {
						position: absolute;
						top: 0;
						left: 50%;
						transform: translateX(-50%);
						height: 100%;
						width: auto;
						max-width: unset;
					}
				}

				& > .content-wrap {
					display: flex;
					flex-direction: column;
					justify-content: flex-start;
					padding-top: $margin-element-medium;
					gap: $margin-element-tiny;
					padding-left: $radius-medium;
				}

				// &:not(:first-child) {
				// 	margin-left: $margin-body-large;
				// }
			}
		}

		&:not(.promo_horizontal):not(.promo_tile) {
			& > .promo-control {
				margin-bottom: $margin-body-large;
				&:not(:last-child) {
					margin-bottom: $margin-element-medium;
				}
			}
		}

		&.promo_vertical {
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			justify-content: space-between;

			& > .promo-control {
				display: flex;
				flex-direction: row;

				& > .img-wrap {
					margin-right: $margin-element-medium;
				}

				& > .content-wrap {
					display: flex;
					flex-direction: column;
					justify-content: flex-start;
					padding-top: $margin-element-medium;
					gap: $margin-element-small;
				}
			}
		}

		&.promo_tile {
			//@include grid-minmax(10em, 1fr);
			//width: 45%;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			gap: $margin-element-medium;

			& > .promo-control {
				& > .img-wrap {
					//border-radius: $radius-medium;
				}
			}
		}
	}
</style>
